import { render, staticRenderFns } from "./BDatepicker.vue?vue&type=template&id=2e046030&scoped=true&"
import script from "./BDatepicker.vue?vue&type=script&lang=js&"
export * from "./BDatepicker.vue?vue&type=script&lang=js&"
import style0 from "./BDatepicker.vue?vue&type=style&index=0&id=2e046030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e046030",
  null
  
)

export default component.exports